import { render, staticRenderFns } from "./BaseReferenceCodeName.vue?vue&type=template&id=9682425e&scoped=true&"
import script from "./BaseReferenceCodeName.vue?vue&type=script&lang=js&"
export * from "./BaseReferenceCodeName.vue?vue&type=script&lang=js&"
import style0 from "./BaseReferenceCodeName.vue?vue&type=style&index=0&id=9682425e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9682425e",
  null
  
)

export default component.exports